// Opens a data: URL (PDF/image) in a new tab without document.write (XSS-safe: no HTML string interpolation).
export function openDataUrl(dataUrl) {
  if (!dataUrl) return;
  try {
    const [meta, b64] = dataUrl.split(",");
    const mime = (meta.match(/^data:([^;]+)/) || [])[1] || "application/octet-stream";
    const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
    const url = URL.createObjectURL(new Blob([bytes], { type: mime }));
    window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    console.error("Could not open document", e);
  }
}
